/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    EVMChain,
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    NftMetadataAttribute,
    NftMetadataAttributeFromJSON,
    NftMetadataAttributeFromJSONTyped,
    NftMetadataAttributeToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Represents metadata for a NFT.
 * @export
 * @interface NftMetadata
 */
export interface NftMetadata {
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    updatedAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    tokenId: number;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    contractAddress: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenName?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenDescription?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftMetadata
     */
    evmChain?: EVMChain;
    /**
     * Traits/attributes/characteristics for each NFT asset.
     * @type {Array<NftMetadataAttribute>}
     * @memberof NftMetadata
     */
    attributes?: Array<NftMetadataAttribute>;
    /**
     * 
     * @type {boolean}
     * @memberof NftMetadata
     */
    isVirtual?: boolean;
}

export function NftMetadataFromJSON(json: any): NftMetadata {
    return NftMetadataFromJSONTyped(json, false);
}

export function NftMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'tokenId': json['tokenId'],
        'contractAddress': json['contractAddress'],
        'tokenUri': !exists(json, 'tokenUri') ? undefined : json['tokenUri'],
        'tokenImageUrl': !exists(json, 'tokenImageUrl') ? undefined : json['tokenImageUrl'],
        'tokenName': !exists(json, 'tokenName') ? undefined : json['tokenName'],
        'tokenDescription': !exists(json, 'tokenDescription') ? undefined : json['tokenDescription'],
        'evmChain': !exists(json, 'evmChain') ? undefined : EVMChainFromJSON(json['evmChain']),
        'attributes': !exists(json, 'attributes') ? undefined : ((json['attributes'] as Array<any>).map(NftMetadataAttributeFromJSON)),
        'isVirtual': !exists(json, 'isVirtual') ? undefined : json['isVirtual'],
    };
}

export function NftMetadataToJSON(value?: NftMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'tokenId': value.tokenId,
        'contractAddress': value.contractAddress,
        'tokenUri': value.tokenUri,
        'tokenImageUrl': value.tokenImageUrl,
        'tokenName': value.tokenName,
        'tokenDescription': value.tokenDescription,
        'evmChain': EVMChainToJSON(value.evmChain),
        'attributes': value.attributes === undefined ? undefined : ((value.attributes as Array<any>).map(NftMetadataAttributeToJSON)),
        'isVirtual': value.isVirtual,
    };
}


